<template>
  <van-popup v-model="show" class="popup">
    <div class="layout">
      <img class="close" src="../assets/close.svg" @click="close" />
      <div class="content">
        <div class="title">
          <div v-html="title"></div>
          <i class="point">·</i>
        </div>
        <div class="inner-content">
          <p class="desc" v-html="content"></p>
        </div>
      </div>
      <button @click="click">{{ buttonText }}</button>
    </div>
  </van-popup>
</template>
<script>
import Vue from "vue";
import { Popup } from "vant";

Vue.use(Popup);
export default {
  data() {
    return {
      show: false,
    };
  },
  created() {
    this.show = this.value;
  },
  props: [
    "value",
    "title",
    "content",
    "buttonText",
    "buttonClick",
    "closeClick",
  ],
  watch: {
    show(val) {
      this.$emit("input", val);
    },
    value(val) {
      this.show = val;
    },
  },
  methods: {
    close(e) {
      this.show = false;
      this.$emit("closeClick",e);
    },
    click(e) {
      this.show = false;
      this.$emit("buttonClick",e);
    },
  },
};
</script>
<style lang="less" scoped>
.popup {
  background: transparent;
  min-width: 250px;
}
.layout {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.close {
  align-self: flex-end;
  width: 26px;
  height: 26px;
}
.content {
  display: flex;
  align-items: center;
  flex-direction: column;
  position: relative;
  overflow: hidden;
  border-radius: 16px;
  background: url("../assets/y-act-alert-dialog.png") 0 0 no-repeat;
  background-size: 100%;
  width: 100%;
  padding-bottom: 40%;
}
.title {
  color: #000;
  font-size: 17px;
  margin-top: 62px;
  font-weight: 600;
  position: relative;
  overflow: hidden;
  padding-bottom: 10px;
  &:before{
    content: '';
    position: absolute;
    bottom: 0px;
    width: 40%;
    height: 1px;
    border-bottom: 1px solid #8D6D41;
    transform: scaleY(0.5); /* 将 1px 的线条缩小为原来的 50% */
    z-index: 0;
  }
  &:after{
    content: '';
    position: absolute;
    bottom: 0px;
    right: 0;
    width: 40%;
    height: 1px;
    border-bottom: 1px solid #8D6D41;
    transform: scaleY(0.5); /* 将 1px 的线条缩小为原来的 50% */
    z-index: 0;
  }
  .point{
    position: absolute;
    bottom: -10px;
    color: #8D6D41;
    text-align: center;
    width: 100%;
    z-index: 1;
    transform: scaleY(0.5); /* 将 1px 的线条缩小为原来的 50% */
  }
}
.inner-content {
  .desc {
    font-size: 17px;
    color: #8D6D41;
    font-weight: 600;
    line-height: 22px;
  }
}
button {
  width: 138px;
  height: 36px;
  background: linear-gradient(90deg, #e8c798, #ecd1bc);
  border-radius: 24px;
  outline: none;
  border: none;
  margin-top: 40px;
}
</style>
